export const clearFocus = (): void => {
    // In some case document.activeElement can be null
    // statement to avoid errors
    if (document.activeElement) {
      (document.activeElement as HTMLElement).blur();
    }
}
